
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Order} from '../core/Order';
import {FieldModelOrder} from '../core/Order';
import {TradeHistoryRecord} from '../entity/TradeHistoryRecord';
import {FieldModelTradeHistoryRecord} from '../entity/TradeHistoryRecord';

/**
 * OrderInsert2ResponseParams struct
 */
class OrderInsert2ResponseParams {
  /**
   * Initialize struct
   * @param {!Order=} order
   * @param {!TradeHistoryRecord=} tradeHistoryRecord
   * @constructor
   */
  constructor (order = new Order(), tradeHistoryRecord = new TradeHistoryRecord()) {
    this.Order = order
    this.TradeHistoryRecord = tradeHistoryRecord
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderInsert2ResponseParams}
   * @param {!OrderInsert2ResponseParams} other Other struct
   * @returns {!OrderInsert2ResponseParams} This struct
   */
  copy (other) {
    if (other.Order != null) {
      this.Order = Order.fromObject(other.Order)
    } else {
      this.Order = null
    }
    if (other.TradeHistoryRecord != null) {
      this.TradeHistoryRecord = TradeHistoryRecord.fromObject(other.TradeHistoryRecord)
    } else {
      this.TradeHistoryRecord = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderInsert2ResponseParams}
   * @returns {!OrderInsert2ResponseParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderInsert2ResponseParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderInsert2ResponseParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderInsert2ResponseParams}
   * @param {!OrderInsert2ResponseParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderInsert2ResponseParams)) {
      throw new TypeError('Instance of OrderInsert2ResponseParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderInsert2ResponseParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Order: ((this.Order != null) ? this.Order : null),
      TradeHistoryRecord: ((this.TradeHistoryRecord != null) ? this.TradeHistoryRecord : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderInsert2ResponseParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderInsert2ResponseParams} other Object value
   * @returns {!OrderInsert2ResponseParams} Created struct
   */
  static fromObject (other) {
    return new OrderInsert2ResponseParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderInsert2ResponseParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderInsert2ResponseParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderInsert2ResponseParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4134
  }
}

export { OrderInsert2ResponseParams };

/**
 * Fast Binary Encoding OrderInsert2ResponseParams field model
 */
class FieldModelOrderInsert2ResponseParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Order = new FieldModelOrder(buffer, 4 + 4)
    this.TradeHistoryRecord = new FieldModelTradeHistoryRecord(buffer, this.Order.fbeOffset + this.Order.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Order.fbeSize + this.TradeHistoryRecord.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Order.fbeExtra + this.TradeHistoryRecord.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderInsert2ResponseParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4134
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Order.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Order.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Order.fbeSize

    if ((fbeCurrentSize + this.TradeHistoryRecord.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradeHistoryRecord.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeHistoryRecord.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @param {!OrderInsert2ResponseParams} fbeValue Default value, defaults is new OrderInsert2ResponseParams()
   * @returns {!OrderInsert2ResponseParams} OrderInsert2ResponseParams value
   */
  get (fbeValue = new OrderInsert2ResponseParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @param {!OrderInsert2ResponseParams} fbeValue OrderInsert2ResponseParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Order.fbeSize) <= fbeStructSize) {
      fbeValue.Order = this.Order.get()
    } else {
      fbeValue.Order = new Order()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Order.fbeSize

    if ((fbeCurrentSize + this.TradeHistoryRecord.fbeSize) <= fbeStructSize) {
      fbeValue.TradeHistoryRecord = this.TradeHistoryRecord.get()
    } else {
      fbeValue.TradeHistoryRecord = new TradeHistoryRecord()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeHistoryRecord.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @param {!OrderInsert2ResponseParams} fbeValue OrderInsert2ResponseParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderInsert2ResponseParams}
   * @param {OrderInsert2ResponseParams} fbeValue OrderInsert2ResponseParams value
   */
  setFields (fbeValue) {
    this.Order.set(fbeValue.Order)
    this.TradeHistoryRecord.set(fbeValue.TradeHistoryRecord)
  }
}

export { FieldModelOrderInsert2ResponseParams };

/**
 * Fast Binary Encoding OrderInsert2ResponseParams model
 */
class OrderInsert2ResponseParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderInsert2ResponseParams(this.buffer, 4)
  }

  /**
   * Get the OrderInsert2ResponseParams model
   * @this {!OrderInsert2ResponseParamsModel}
   * @returns {!FieldModelOrderInsert2ResponseParams} model OrderInsert2ResponseParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderInsert2ResponseParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderInsert2ResponseParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderInsert2ResponseParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderInsert2ResponseParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderInsert2ResponseParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderInsert2ResponseParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderInsert2ResponseParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderInsert2ResponseParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderInsert2ResponseParamsModel}
   * @param {!OrderInsert2ResponseParams} value OrderInsert2ResponseParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderInsert2ResponseParamsModel}
   * @param {!OrderInsert2ResponseParams} value OrderInsert2ResponseParams value, defaults is new OrderInsert2ResponseParams()
   * @return {!object} Deserialized OrderInsert2ResponseParams value and its size
   */
  deserialize (value = new OrderInsert2ResponseParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderInsert2ResponseParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderInsert2ResponseParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderInsert2ResponseParamsModel}
   * @param {!number} prev Previous OrderInsert2ResponseParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderInsert2ResponseParamsModel };
